import React, { Component } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import fundo_amarelo from '../../assets/fundo_amarelo.png';
import { InputText } from 'primereact/inputtext';
import { Growl } from 'primereact/growl';
import {
    FacebookIcon,
    LinkedinIcon,
    TwitterIcon,
    WhatsappIcon
} from 'react-share';
import { decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

class MeuLink extends Component {
    constructor() {
        super();
        this.state = {
            link: '',
            items: [
                {
                    label: 'Update',
                    icon: 'pi pi-refresh',
                    command: e => {
                        this.growl.show({ severity: 'success',
                            summary: 'Updated',
                            detail: 'Data Updated' });
                    }
                }
            ]
        };

        this.save = this.save.bind(this);
    }

    componentDidMount() {
        const token = localStorage.getItem('token');

        this.setState({ nome: decriptoLocalStorage('Nome')?.decriptoValue });
        this.setState({ link: decriptoLocalStorage('Link')?.decriptoValue });
    }

    buscaUsuario(e) {
        e.preventDefault();

        const dataToSend = {
            Email: this.state.email,
            Password: this.state.senha,
            Value: this.state.value
        };

        fetch(`${this.url  }/auth`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        })
            .then(response => response.json())
            .then(responseJson => {
                if (responseJson) {
                    localStorage.setItem('token', responseJson[Object.keys(responseJson)[0]]);
                    this.props.history.push('/');
                    window.location.reload();
                }
            })
            .catch(err => {
            });
    }

    save() {
        this.growl.show({ severity: 'success',
            summary: 'Sucesso',
            detail: 'Copiado' });
    }

    handleSubmit = e => {
        document.getElementById('link').select();
        document.execCommand('copy');
        this.save();
    }

    render() {
        const header = (
            <img alt="Card" src={fundo_amarelo} />
        );
        const footer = (

            <span>
                <Button label="Save" icon="pi pi-checkv" className="p-col-12 p-md-12 p-lg-12" />
            </span>
        );

        return (

            <div className="p-grid">
                <Growl ref={el => this.growl = el}></Growl>
                <div className="p-col-12 p-md-12 p-lg-12">
                    <Panel header="Compartilhe seu link e melhores seus ganhos">
                        <p>Você pode compartilhar seu link copiando e colando em sua rede social ou whatsapp.</p>

                    </Panel>

                </div>

                <div className="p-col-12 p-md-12 p-lg-12">
                    <Card className="ui-card-shadow" header={header}>
                        <form onSubmit={this.handleSubmit}>
                            <InputText className="p-col-9 p-md-9 p-lg-9" style={{ background: 'rgb(64, 62, 65)',
                                color: '#fff' }} id="link" name="link" value={this.state.link} /><span className="p-col-1 p-md-1 p-lg-1" disabled="true" />
                            <Button label="Copiar" icon="pi pi-copy" iconPos="right" model={this.state.items} />
                        </form>
                    </Card>
                </div>
                <div className="p-col-12 p-md-12 p-lg-12">
                    <Card className="ui-card-shadow " >
                        <p>Você pode também, compartilhar direto, clicando nas opções abaixo.</p>
                    </Card>

                </div>
                <div className="p-col-12 p-md-6 p-lg-3">
                    <Card className="ui-card-shadow " >
                        <div>
                            <a href={`https://api.whatsapp.com/send?text=${  this.state.link}`}
                                target="_blank" className="p-col-12 p-md-12 p-lg-12 linkCompartilhar"
                                style={{ background: 'rgb(118, 223, 153)',
                                    color: '#fff',
                                    fontSize: '25px' }}
                                rel="noreferrer"
                            ><WhatsappIcon /></a>
                        </div>
                    </Card>
                </div>
                <div className="p-col-12 p-md-6 p-lg-3">
                    <Card className="ui-card-shadow "  >
                        <div>
                            <a href={`https://twitter.com/intent/tweet?text=${  this.state.link}`}
                                style={{ background: 'rgb(0,191,255)',
                                    color: '#fff',
                                    fontSize: '25px' }}
                                target="_blank"
                                title="Tweet"
                                className="p-col-12 p-md-12 p-lg-12" rel="noreferrer"
                            ><TwitterIcon /></a>
                        </div>
                    </Card>
                </div>
                <div className="p-col-12 p-md-6 p-lg-3">
                    <Card className="ui-card-shadow " >
                        <div>
                            <a href={`https://linkedin.com/shareArticle?mini=true&url=${  this.state.link}`}
                                target="_blank" title="Tweet"
                                style={{ background: 'rgb(135,206,235)',
                                    color: '#fff',
                                    fontSize: '25px' }}
                                className="p-col-12 p-md-12 p-lg-12" rel="noreferrer"
                            ><LinkedinIcon /></a>
                        </div>
                    </Card>
                </div>
                <div className="p-col-12 p-md-6 p-lg-3">
                    <Card className="ui-card-shadow " >
                        <div>
                            <a href={`https://facebook.com/sharer/sharer.php?u=${  this.state.link}`}
                                target="_blank" title="Tweet"
                                style={{ background: 'rgb(76, 128, 196)',
                                    color: '#fff',
                                    fontSize: '25px' }}
                                className="p-col-12 p-md-12 p-lg-12" rel="noreferrer"
                            ><FacebookIcon /></a>
                        </div>
                    </Card>
                </div>
                <div className="p-col-12 p-md-6 p-lg-3">
                </div>

            </div>
        );
    }
}

export default MeuLink;
